import {
  FaDownload,
  FaGooglePlay,
  FaApple,
  FaBolt,
  FaCreditCard,
  FaMobileAlt,
  FaShieldAlt,
  FaMoneyBillWave
} from 'react-icons/fa';

const PaymentChannels = () => {

  const paymentChannels = [
    {
      id: 1,
      name: "Itex Integrated (PayVice)",
      imageIcon: "/images/Payvice-150x150.webp",
      description: "Secure platform for electricity and service payments.",
      icon: <FaShieldAlt className="text-white" />,
      color: "bg-black",
      textColor: "text-white",
      link: "/file/ItexPAYVICE-PAYMENT-MADE-EASY.pptx",
      applelink: "https://apps.apple.com/us/app/payvice-avantus/id1634955295",
      playstorlink: "https://play.google.com/store/apps/details?id=com.iisysgroup.payviceagents"
    },
    {
      id: 2,
      name: "Moniepoint",
      imageIcon: "/images/Monniepoint-150x150.webp",
      description: "Personal banking, transfers and bill payments.",
      icon: <FaMoneyBillWave className="text-white" />,
      color: "bg-[#14532d]",
      textColor: "text-white",
      link: "/file",
      applelink: "https://apps.apple.com/us/app/moniepoint-personal-banking/id6452756675",
      playstorlink: "https://play.google.com/store/apps/details?id=com.moniepoint.personal"
    },
    {
      id: 3,
      name: "Pagatech (Paga)",
      imageIcon: "/images/Paga-150x150.webp",
      description: "Pay bills, send money and manage electricity payments.",
      icon: <FaCreditCard className="text-white" />,
      color: "bg-green-700",
      textColor: "text-white",
      link: "/file/Manual-for-Pagatech.docx",
      applelink: "https://apps.apple.com/ng/app/paga-send-pay-and-bank/id1362357426",
      playstorlink: "https://play.google.com/store/apps/details?id=com.mypaga.customer"
    },
    {
      id: 4,
      name: "iRecharge",
      imageIcon: "/images/iRecharge-150x150.webp",
      description: "Recharge electricity, airtime and utility services.",
      icon: <FaBolt className="text-white" />,
      color: "bg-yellow-400",
      textColor: "text-black",
      link: "/file/Irecharge_Step-by-step-guide-on-how-to-purchase-BEDC-tokens-on-the-iRecharge-mobile-app-1.pdf",
      applelink: "https://play.google.com/store/apps/details?id=com.ist.irecharge",
      playstorlink: "https://apps.apple.com/ng/app/irecharge/id971084808"
    },
    {
      id: 5,
      name: "CoralPay (BillerOne)",
      imageIcon: "/images/Coralplay-150x150.webp",
      description: "Enterprise-grade bill payments and transaction processing.",
      icon: <FaShieldAlt className="text-white" />,
      color: "bg-green-900",
      textColor: "text-white",
      link: "/file/CoralPay_BEDC-userflow.pdf",
      applelink: "https://apps.apple.com/ng/app/billerone-bills-payments/id1633836689",
      playstorlink: "https://play.google.com/store/apps/details?id=com.coralpay.billerone"
    },
    // {
    //   id: 6,
    //   name: "Baxi Mobile",
    //   imageIcon: "/images/Baxi-150x150.webp",
    //   description: "Utility payments, electricity tokens and digital services.",
    //   icon: <FaMobileAlt className="text-white" />,
    //   color: "bg-black",
    //   textColor: "text-white",
    //   link: "/file/Baxi-2.0-Manual-BEDC.pdf",
    //   applelink: "https://play.google.com/store/apps/details?id=com.capricorn.baximobile.app",
    //   playstorlink: "https://apps.apple.com/us/app/baxi-mobile/id1500278465"

    // }
  ];

  return (
    <div className="w-full min-h-screen bg-white">
     <div className="relative bg-[#14532d] text-white py-12 md:py-16 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}> 
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 relative z-10">
          <div className="flex flex-col lg:flex-row items-center justify-between">
            <div className="lg:w-2/3">
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight  uppercase tracking-tight">
              Payment <span className="text-yellow-400">Channels</span>
              </h2>
              <div className="w-20 h-1.5 bg-yellow-400 rounded-full mb-6"></div>
            </div>
          
          </div>
        </div>
    </div>

      <div className="max-w-7xl mx-auto px-4 py-16 font-sans text-gray-800 lg:px-16">
        {/* Header Section */}
        <div className="text-center mb-20">
          <h2 className="text-3xl md:text-5xl font-black text-black mb-8 uppercase tracking-tighter">
            Pay your <span className="text-green-700">BEDC Bills</span> Easily
          </h2>
          <p className="text-gray-600 text-xl max-w-3xl mx-auto font-medium leading-relaxed">
            Pay your BEDC Electricity Bills quickly and securely using any of our trusted payment partners.
            Seamless bill lookup and instant token generation at your fingertips.
          </p>
        </div>

        {/* Payment Channels Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {paymentChannels.map((channel) => (
            <div
              key={channel.id}
              className={`${channel.color} ${channel.textColor} rounded-[2.5rem] p-10 shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-white/10 group relative overflow-hidden`}
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-transform duration-700"></div>

              {/* Channel Header */}
              <div className="flex flex-col mb-8 relative z-10">
                <div className="bg-white p-4 rounded-2xl shadow-lg w-fit mb-6 ring-4 ring-white/10">
                  <img src={channel.imageIcon} alt={channel.name} className="w-12 h-12 object-contain" />
                </div>
                <h3 className="text-2xl font-black uppercase tracking-tight">{channel.name}</h3>
                <p className={`mt-2 font-medium opacity-80`}>{channel.description}</p>
              </div>

              {/* Agent Guide Button */}
              <div className="mb-8 relative z-10">
                <a
                  href={channel.link}
                  download
                  className="flex items-center justify-center w-full bg-white hover:bg-yellow-400 text-black font-black py-4 px-6 rounded-2xl transition-all duration-300 shadow-xl uppercase text-xs tracking-widest gap-2"
                >
                  <FaDownload size={16} className={`${channel.color === 'bg-yellow-400' ? 'text-green-700' : 'text-green-700'}`} />
                  Download User Guide
                </a>
              </div>

              {/* App Store Buttons */}
              <div className="flex flex-col sm:flex-row gap-3 relative z-10">
                <a
                  href={channel.applelink}
                  className="flex-1 flex items-center justify-center bg-black/40 hover:bg-black text-white py-3 px-4 rounded-xl transition-all duration-300 border border-white/20"
                >
                  <FaApple className="mr-2 text-xl" />
                  <div className="text-left">
                    <div className="text-[8px] font-black uppercase opacity-60">Store</div>
                    <div className="text-[10px] font-black uppercase">App Store</div>
                  </div>
                </a>

                <a
                  href={channel.playstorlink}
                  className="flex-1 flex items-center justify-center bg-black/40 hover:bg-black text-white py-3 px-4 rounded-xl transition-all duration-300 border border-white/20"
                >
                  <FaGooglePlay className="mr-2 text-xl" />
                  <div className="text-left">
                    <div className="text-[8px] font-black uppercase opacity-60">Store</div>
                    <div className="text-[10px] font-black uppercase">Play Store</div>
                  </div>
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Footer Note */}
        <div className=" pt-5 border-t border-gray-100 text-center">
          <div className="inline-block p-6 bg-gray-50 rounded-3xl border border-gray-100">
            <p className="text-gray-700 text-sm font-medium max-w-2xl mx-auto leading-relaxed">
              All payment channels are secure and trusted partners of BEDC Electricity Plc.
              For assistance, contact our 24/7 customer support at <span className="text-green-700 font-bold">customercomplaints@beninelectric.com</span> or call <span className="text-green-700 font-bold">0700 000 2332</span>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentChannels;